import { decodeToken } from ".";
import { SUBMISSION_DISABLED } from "../constants";

export const preventRender = ({ id }: { id: string }) => {
  // Editor canvas, preview links, primary-version preview: render the button
  // visually (designers need to see it). Submission is already gated by
  // SUBMISSION_DISABLED in useForm and useSealValidation, so clicks are inert.
  if (SUBMISSION_DISABLED) return false;

  const { analyticsData } = window;
  const acceptToken: string =
    sessionStorage.getItem("accept-token-2krBd1i2VjStO00") || "";
  const decoded = decodeToken(acceptToken);
  const isV2Flow = Boolean((window as any).__SD_DATA__?._acceptToken);

  const tokenMismatch = isV2Flow
    ? analyticsData?.versionId !== decoded?.versionId
    : decoded?.elementId !== id || analyticsData?.storyId !== decoded?.storyId;

  const isEmpty = tokenMismatch && analyticsData;

  return isEmpty;
};
